import { useState } from 'react'
import { expenseAPI } from '../services/api'
import { CATEGORIES } from '../utils/helpers'

export default function ExpenseForm({ expense, onClose, onSuccess }) {
  const [form, setForm] = useState({
    amount: expense?.amount 
      ? String(expense.amount).replace(/\B(?=(\d{3})+(?!\d))/g, '.') 
      : '',
    category: expense?.category || 'food',
    date: expense?.date || new Date().toISOString().split('T')[0],
    description: expense?.description || '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const formatAmount = (value) => {
    const numbers = value.replace(/\D/g, '')
    return numbers.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const numericAmount = parseInt(form.amount.replace(/\D/g, ''))

    if (!numericAmount || !form.category || !form.date) {
      setError('Jumlah, kategori, dan tanggal wajib diisi')
      return
    }

    setLoading(true)
    try {
      const payload = {
        amount: numericAmount,
        category: form.category,
        date: form.date,
        description: form.description,
      }

      if (expense?.id) {
        await expenseAPI.update(expense.id, payload)
      } else {
        await expenseAPI.create(payload)
      }
      onSuccess()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-sm max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-lg">
              {expense?.id ? 'Edit Pengeluaran' : 'Tambah Pengeluaran'}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
          </div>

          {error && (
            <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm mb-4">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Amount */}
            <div>
              <label className="label">Jumlah *</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">Rp</span>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="0"
                  value={form.amount}
                  onChange={(e) => setForm({ ...form, amount: formatAmount(e.target.value) })}
                  className="input-field pl-10"
                  autoFocus
                />
              </div>
            </div>

            {/* Category */}
            <div>
              <label className="label">Kategori *</label>
              <div className="grid grid-cols-4 gap-2">
                {CATEGORIES.map((cat) => (
                  <button
                    key={cat.value}
                    type="button"
                    onClick={() => setForm({ ...form, category: cat.value })}
                    className={`p-2 rounded-lg text-center transition-all ${
                      form.category === cat.value
                        ? 'bg-primary text-white'
                        : 'bg-gray-100 hover:bg-gray-200'
                    }`}
                  >
                    <div className="text-lg">{cat.icon}</div>
                    <div className="text-xs mt-0.5 leading-tight">{cat.label.split(' ')[0]}</div>
                  </button>
                ))}
              </div>
            </div>

            {/* Date */}
            <div>
              <label className="label">Tanggal *</label>
              <input
                type="date"
                value={form.date}
                onChange={(e) => setForm({ ...form, date: e.target.value })}
                className="input-field"
              />
            </div>

            {/* Description */}
            <div>
              <label className="label">Catatan (Opsional)</label>
              <input
                type="text"
                placeholder="Tambahkan catatan..."
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                className="input-field"
              />
            </div>

            <div className="flex gap-3 pt-2">
              <button type="button" onClick={onClose} className="btn-secondary flex-1">
                Batal
              </button>
              <button
                type="submit"
                disabled={loading || !form.amount}
                className="btn-primary flex-1 disabled:opacity-50"
              >
                {loading ? 'Menyimpan...' : expense?.id ? 'Update' : 'Simpan'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
